import { render } from "./InviteProfessionalAction.vue?vue&type=template&id=1f5af47b&scoped=true"
import script from "./InviteProfessionalAction.vue?vue&type=script&lang=js"
export * from "./InviteProfessionalAction.vue?vue&type=script&lang=js"

import "./InviteProfessionalAction.vue?vue&type=style&index=0&id=1f5af47b&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5af47b"]])

export default __exports__